import { createI18n } from 'vue-i18n'
import fr from './locales/fr.json'
import en from './locales/en.json'
import ar from './locales/ar.json'

/**
 * Factory : une instance i18n PAR application. Indispensable en SSG —
 * vite-ssg rend les pages en parallèle, un singleton partagé ferait
 * fuiter la locale d'une page dans une autre (course sur locale.value).
 */
export function createI18nInstance() {
  return createI18n({
    legacy: false,
    locale: 'fr', // langue par défaut
    fallbackLocale: 'en',
    messages: {
      fr,
      en,
      ar
    }
  })
}
